<template>
    <div class="container-fluid">
        <div class="login">
            <div class="card text-center p-sm-5 p-3" style="width: 25rem;">
                <div class="card-body">

                    403 - Access denied
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "unauthorized",
    }
</script>

<style scoped>
    .container-fluid {
        height: 100vh;
        background: transparent linear-gradient(270deg, #73AFE3 0%, #CFE4F6 100%) 0% 0% no-repeat padding-box;
        opacity: 1;
    }

    .login {
        display: flex;
        height: 100vh;
        align-items: center;
        justify-content: center;
    }

    .card {
        background: #4192D9 0% 0% no-repeat padding-box;
        box-shadow: 1px 5px 10px #00000029;
        border-radius: 20px;
        opacity: 1;
    }

    .form-control {
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 1px 5px 10px #00000029 !important;
        border-radius: 4px !important;
        height: calc(1.5em + .75rem + 8px) !important;
        font-size: 15px !important;
    }

    .text-white {
        font-size: 15px !important;
    }

    .btn {
        background: #292929 0% 0% no-repeat padding-box;
        box-shadow: 1px 5px 10px #00000029 !important;
        border-radius: 4px !important;
        padding-left: 15%;
        padding-right: 15%;
        font-size: 18px !important;
    }


</style>
